import { ICommonIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders a note/camera like icon with a small clock on bottom right.
 */
export function BankNoteClockIcon({ className }: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M11 15.9H3.9A1.9 1.9 0 0 1 2 14V4.9C2 3.85 2.85 3 3.9 3h15.2c1.05 0 1.9.85 1.9 1.9V10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M13.179 7.97a2.376 2.376 0 0 1-3.359 3.36 2.376 2.376 0 0 1 3.359-3.36M6 13H5M18 6h-1M18 21a4 4 0 0 1-4-3.999c0-2.164 1.84-4.002 4.004-4.001A4 4 0 0 1 18 21"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M19.2 17h-1.6v-1.6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
